import { BaseRegister } from '@/newApi/controllers/BaseRegister';
import { EmployeeService } from '@/newApi/controllers/EmployeeService';
import { UserService } from '@/newApi/controllers/UserService';
import {
    Analytics,
    Discussions,
    PayManagement,
    PayEquityAnalysis,
    PayEquityAuditService,
} from '@/newApi/controllers';
import { EmploymentService } from '@/newApi/controllers/EmploymentService';

class NewApi {
    public analytics = new Analytics();

    public discussions = new Discussions();

    public payManagement = PayManagement;

    public payEquityAnalysis = new PayEquityAnalysis();

    public baseRegister = new BaseRegister();

    public employee = new EmployeeService();

    public employment = new EmploymentService();

    public user = new UserService();

    public PayEquityAuditService = new PayEquityAuditService();

    public abort(): void {
        this.analytics.abort();
        this.baseRegister.abort();
        this.discussions.abort();
        this.user.abort();
        this.PayEquityAuditService.abort();
        this.payManagement.abort();
    }
}

export const newApi = new NewApi();
